import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class NotificationsApi extends CollectionApi {
  /**
   * @description Set up the notifications api
   */
  constructor() {
    super('/api/notifications', {
      limit: 10,
      skip: 0,
      sort: '-created',
    });
  }

  /**
   * @description Used in the notifications workflow to get the notifications in a
   * grouped format - grouped by User, Group and Security alerts.
   */
  getGroupedNotifications() {
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}/grouped`).then(resp => resp.data));
  }
}

export default new NotificationsApi();
